<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <CasesContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import CasesContent from "~~/codepresso-renewal/content/CasesContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "고객 사례 — 익명의 후기가 아니라 실명과 숫자로 증명합니다 | 코드프레소",
  meta: [
    { name: "description", content: "숫자로 증명하는 전환. 익명의 후기가 아닙니다. 실명과 숫자로 공개합니다." },
    { name: "title", content: "고객 사례 — 익명의 후기가 아니라 실명과 숫자로 증명합니다 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "고객 사례 — 익명의 후기가 아니라 실명과 숫자로 증명합니다 | 코드프레소" },
    { property: "og:description", content: "숫자로 증명하는 전환. 익명의 후기가 아닙니다. 실명과 숫자로 공개합니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/cases.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
